import React, { useState } from 'react';
import { dersLabel, dersRenk, kazanimSozleri } from '../../lib/dersler';

// SEÇİM ÖZETİ (2026-10-31, kullanıcı isteği): sepete eklenen sorular sayfanın yanında, kaydırınca
// birlikte kayan kartta — hangi dersten, hangi öğrenme çıktısından kaç soru seçildiği. Yalnız
// müşterinin KENDİ seçimi sayılır (havuz sayısı gösterilmez — MusteriPaneli başlığındaki kural).
// Kaynak GET /api/musteri/sepet kalemleri (ders, kazanim_kodu, kazanim_adi, mufredat).

/** Kalemleri ders -> öğrenme çıktısı ağacına toplar. Sıra: ders adı, kod. */
export function secimAgaci(kalemler) {
  const dersler = new Map();
  for (const k of kalemler) {
    const d = k.ders || '';
    if (!dersler.has(d)) dersler.set(d, { ders: d, sorular: [], ciktilar: new Map() });
    const dd = dersler.get(d);
    dd.sorular.push(k.soru_no);
    const kod = k.kazanim_kodu || '';
    if (!dd.ciktilar.has(kod)) dd.ciktilar.set(kod, { kod, ad: k.kazanim_adi || '', mufredat: k.mufredat, sorular: [] });
    dd.ciktilar.get(kod).sorular.push(k.soru_no);
  }
  const ad = (d) => (d ? dersLabel(d) : 'Diğer');
  return [...dersler.values()]
    .sort((a, b) => ad(a.ders).localeCompare(ad(b.ders), 'tr'))
    .map((d) => ({ ...d, ad: ad(d.ders), ciktilar: [...d.ciktilar.values()].sort((a, b) => a.kod.localeCompare(b.kod, 'tr', { numeric: true })) }));
}

export default function MusteriSecimOzeti({ kalemler, onSepeteGit, onCikar, mesgul }) {
  const [acik, setAcik] = useState(() => new Set());
  const agac = secimAgaci(kalemler);
  const ac = (k) => setAcik((o) => { const n = new Set(o); if (n.has(k)) n.delete(k); else n.add(k); return n; });
  return (
    <aside data-secim-ozeti aria-label="Seçtiğiniz sorular"
      className="lg:sticky lg:top-4 flex max-h-[60vh] lg:max-h-[calc(100vh-2rem)] flex-col overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
      <header className="flex items-baseline justify-between gap-2 border-b border-gray-200 bg-gray-50 px-4 py-2.5">
        <h2 className="text-sm font-bold text-gray-800">Seçimleriniz</h2>
        {kalemler.length > 0 && <span data-secim-adet className="text-xs font-semibold text-green-700">{kalemler.length} soru</span>}
      </header>
      {kalemler.length === 0 ? (
        <p className="px-4 py-6 text-center text-xs text-gray-500">
          Henüz soru seçmediniz. Sepete eklediğiniz sorular burada ders ve öğrenme çıktısına göre listelenir.
        </p>
      ) : (
        <div className="min-h-0 flex-1 overflow-y-auto">
          {agac.map((d) => (
            <section key={d.ders || 'diger'} data-ozet-ders={d.ders} className="border-b border-gray-100 last:border-b-0">
              <div className="flex items-center justify-between gap-2 px-4 pb-1 pt-2.5">
                <span className="flex min-w-0 items-center gap-1.5 text-[13px] font-semibold text-gray-800">
                  <span aria-hidden="true" className="h-2.5 w-2.5 shrink-0 rounded-sm" style={{ backgroundColor: d.ders ? dersRenk(d.ders) : '#9CA3AF' }} />
                  <span className="truncate">{d.ad}</span>
                </span>
                <span className="shrink-0 rounded-full bg-gray-100 px-2 py-0.5 text-[11px] font-semibold tabular-nums text-gray-700">{d.sorular.length}</span>
              </div>
              <ul className="pb-2">
                {d.ciktilar.map((c) => {
                  const anahtar = `${d.ders}|${c.kod}`;
                  const soz = kazanimSozleri(c.mufredat);
                  return (
                    <li key={anahtar} data-ozet-cikti={c.kod}>
                      <button type="button" onClick={() => ac(anahtar)} aria-expanded={acik.has(anahtar)}
                        title={c.ad ? `${soz.Ad}: ${c.kod} — ${c.ad}` : undefined}
                        className="flex w-full items-start gap-2 px-4 py-1 text-left hover:bg-gray-50">
                        <span className="min-w-0 flex-1 text-[11.5px] leading-snug text-gray-600">
                          {c.kod ? <span className="font-mono text-blue-700">{c.kod}</span> : <span className="italic">Öğrenme çıktısı yok</span>}
                          {c.ad && <span className="line-clamp-2"> {c.ad}</span>}
                        </span>
                        <span className="shrink-0 pt-px text-[11px] font-semibold tabular-nums text-gray-700">{c.sorular.length}</span>
                      </button>
                      {acik.has(anahtar) && (
                        <div className="flex flex-wrap gap-1 px-4 pb-1.5 pt-0.5">
                          {c.sorular.map((n) => (
                            <span key={n} className="inline-flex items-center gap-1 rounded border border-green-200 bg-green-50 px-1.5 py-0.5 font-mono text-[11px] text-green-800">
                              #{n}
                              <button type="button" aria-label={`#${n} sepetten çıkar`} disabled={mesgul} onClick={() => onCikar(n)}
                                className="text-green-700 hover:text-red-600 disabled:opacity-50">×</button>
                            </span>
                          ))}
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>
            </section>
          ))}
        </div>
      )}
      {kalemler.length > 0 && (
        <footer className="border-t border-gray-200 bg-gray-50 px-4 py-2.5">
          <button type="button" data-ozet-sepete-git onClick={onSepeteGit}
            className="w-full rounded-md bg-blue-600 px-3 py-1.5 text-sm font-semibold text-white hover:bg-blue-700">
            Sepete git ve sipariş ver
          </button>
        </footer>
      )}
    </aside>
  );
}
